module.exports = __webpack_public_path__ + "static/img/es-ga.9c7550ac.svg";